/**
 * Theme system entry point.
 *
 * Pre-builds all 6 MUI themes at import time so theme switching is instant
 * (no createTheme call on every toggle).
 *
 * @module themes
 */

import { createEllafinTheme } from './createEllafinTheme';
import { allThemeConfigs } from './themeConfigs';

/**
 * Default theme ID used when no preference is stored.
 * @type {string}
 */
export const DEFAULT_THEME_ID = 'midnight-navy';

/**
 * Map of theme ID to pre-built MUI theme object.
 * @type {Map<string, import('@mui/material/styles').Theme>}
 */
export const themes = new Map(
  allThemeConfigs.map((config) => [config.id, createEllafinTheme(config)])
);

/**
 * Array of theme metadata for use in the selector UI.
 * Each entry contains the id, name, bold flag, and primary color for swatch display.
 *
 * @type {Array<{ id: string, name: string, bold: boolean, primary: string, heroBackground: string }>}
 */
export const themeList = allThemeConfigs.map(
  ({ id, name, bold, primary, heroBackground }) => ({
    id,
    name,
    bold,
    primary,
    heroBackground,
  })
);

export { createEllafinTheme } from './createEllafinTheme';
// Re-export for convenience
export { allThemeConfigs } from './themeConfigs';
